// PCM16 helpers for the realtime voice pipeline.
//
// The OpenAI Realtime API exchanges 16-bit little-endian PCM mono audio at
// 24 kHz, base64 encoded inside JSON events. Capture and playback both run
// on a 24 kHz AudioContext so no resampling is needed here.

export const SAMPLE_RATE = 24000;

/** Convert a Float32 sample buffer ([-1,1]) to 16-bit PCM. */
export function floatTo16BitPCM(float32) {
  const out = new Int16Array(float32.length);
  for (let i = 0; i < float32.length; i += 1) {
    const s = Math.max(-1, Math.min(1, float32[i]));
    out[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }
  return out;
}

/** Base64 encode an Int16Array (its underlying bytes). */
export function int16ToBase64(int16) {
  const bytes = new Uint8Array(int16.buffer, int16.byteOffset, int16.byteLength);
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

/** Decode a base64 PCM16 payload into an Int16Array. */
export function base64ToInt16(b64) {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new Int16Array(bytes.buffer, 0, Math.floor(bytes.byteLength / 2));
}

/** Convert 16-bit PCM back to Float32 ([-1,1]) for AudioBuffer playback. */
export function int16ToFloat32(int16) {
  const out = new Float32Array(int16.length);
  for (let i = 0; i < int16.length; i += 1) {
    out[i] = int16[i] / (int16[i] < 0 ? 0x8000 : 0x7fff);
  }
  return out;
}
